<template>
  <div :class="['el-input', disabled?'is-disabled':'']">
    <div class="el-input__inner"
         :placeholder="placeholder"
         :contenteditable="!disabled"
         v-html="html"
         @keydown.enter.prevent="() => false"
         @paste.prevent="onPaste"
         @blur="input"></div>
    <span class="el-input__prefix" v-if="icon">
      <i :class="['el-input__icon', icon]"></i>
    </span>
  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  components: {},
  props: {
    value: String,
    icon: String,
    placeholder: String,
    innerClass: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      html: this.value,
      inputHtml: '',
    }
  },
  computed: {},
  watch: {
    value () {
      if (this.value !== this.inputHtml) {
        this.html = this.value
      }
    },
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    input ($event) {
      this.inputHtml = $event.target.innerHTML
      this.inputHtml = _.replace(this.inputHtml, '<br>', '')
      this.$emit('input', this.inputHtml)
    },
    onPaste (e) {
      if (e.clipboardData && window.getSelection) {
        let text = e.clipboardData.getData('text')
        if (text !== '' && text !== null) {
          let textNode = document.createTextNode(text)
          let range = window.getSelection().getRangeAt(0)
          range.deleteContents()
          range.insertNode(textNode)
        }
      } else {
        this.$message.error('请使用chrome浏览器操作')
      }
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.el-textarea {
  height: 40px;
}
.el-input__inner {
  resize: none;
  line-height: 40px;
  padding-left: 30px;

  &[contenteditable=true]:empty:before{
    color: #c7cbd1;
    content: attr(placeholder);
    display: block; /* For Firefox */
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/InlineInputHtml.vue